export default __webpack_public_path__ + "static/media/404Error.da570a7c.svg";